<template>
  <v-container>
    <v-dialog v-model="hasUnfinishedSearch">
      <v-card>
        <v-card-title><span class="text-h5">Resume Search</span></v-card-title>
        <v-card-text> Do You want to resume your last search?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="resumeSearch"> Yes </v-btn>
          <v-btn color="blue darken-1" text @click="leaveOldSearch"> No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <SurveyEffort
      :selected_record="survey_effort_record"
      :notSearch="notSearch"
      v-on="handler"
    />
    <BreadCrumb
      v-if="!notSearch"
      :selected_record="survey_effort_record"
      v-on="handler"
    />
    <v-tabs v-model="tab" slider-color="blue">
    <v-tab v-for="page in pages" :key="`t-${page}`"> {{ page }}</v-tab>
    </v-tabs>
    <v-window v-model="tab">
      <v-window-item v-for="page in pages" :key="`w-${page}`">
        <ObservationForm
          :surveyTs="survey_effort_record.survey_ts"
          :tabType="page"
          v-on="handler"
          :notSearch="notSearch"
        />
      </v-window-item>
    </v-window>
  </v-container>
</template>

<script>
import support from "../plugins/support";
import ObservationForm from 'search-observe-app/components/Observation.vue';
import SurveyEffort from 'search-observe-app/components/SurveyEffort.vue';
import BreadCrumb from "../components/BreadCrumb";


export default {
  name: "Search-Form",

  components: {
    SurveyEffort,
    BreadCrumb,
    ObservationForm,
  },
  props: {
    datatype: String,
  },
  data() {
    return {
      handler: {
        dropCrumb: this.dropCrumb,
      },
      tab: null,
      required: [(v) => !!v || "Required"],
      pages: Object.keys(support.data.tabTableMap),
    };
  },
  computed: {
    hasUnfinishedSearch() {
      return this.$store.getters['shared/getAttribute']("unfinishedSearch") != null;
    },
    hasSurvey() {
      if (
        this.notSearch &
        (this.survey_effort_record.reporter_name != "" &&
          this.survey_effort_record.reporter_name != "guest")
      ) {
        return true;
      } else if (!this.notSearch & (this.insert_ts != "")) {
        return true;
      } else {
        return false;
      }
    },
    survey_effort_record() {
      return support.provideRecord(support.data.SURVEYEFFORT);
    },
    notSearch() {
      return !this.$store.getters['shared/isLoggedIn'] || this.$store.getters['shared/isIncidental'];
    },
    dbName() {
      return this.$store.getters['shared/dbName'];
    },
    databaseSet() {
      return !(
        this.dbName == undefined ||
        this.dbName == null ||
        this.dbName == ""
      );
    },
  },
  async mounted() {
    console.log(this.pages)
    support.findUnfinishedSearch(new Date());
    support.startWatch();
    this.kickback();
    this.$watch(
      "dbName",
      () => {
        this.kickback();
      },
      { deep: true }
    );
    this.$watch(
      "survey_effort_record",
      () => {
        console.log("record changed" + this.survey_effort_record.insert_ts);
      },
      { deep: true }
    );
    if (!this.notSearch && this.survey_effort_record.observer_code == "guest") {
      console.log(this.$store.getters.username);
      console.log(this.survey_effort_record.observer_code);
      this.survey_effort_record.observer_code == this.$store.getters.username;
    }
  },
  methods: {
    resumeSearch() {
      Object.keys(this.$store.getters['shared/dataTables']).forEach((key) =>{
        support.restoreFromLocal(key).then(function() 
        { //most tables get set to a position of -1
          this.$store.dispatch("shared/shiftPosition", {
            table: key,
            position: -1,
          });
          //survey gets set to the position of the record matching our desired survey
          if (key === support.data.SURVEYEFFORT) {
          let newposition = support.findRecordPosition(
            support.data.SURVEYEFFORT,
            this.$store.getters['shared/unfinishedSearch']
          );

          this.$store.dispatch("shared/shiftPosition", {
            table: support.data.SURVEYEFFORT,
            position: newposition,
          });
          this.$store.commit("shared/setAttribute", {
            attribute: "unfinishedSearch",
            value: null,
          });
        }
      }.bind(this));
      });
      
    },
    leaveOldSearch() {
      this.$store.commit("shared/setAttribute", {
        attribute: "unfinishedSearch",
        value: null,
      });
    },
    dropCrumb(crumbInfo) {
      support.saveRecord(support.data.SURVEYEFFORT, this.survey_effort_record);
      let record = support.newBreadCrumb();
      record.breadcrumb_location_code = crumbInfo.code;
      record.ts = crumbInfo.ts;
      support.saveRecord(support.data.SURVEYBREADCRUMB, record);
      support.submitData();
    },
    asBoolean(b) {
      return support.asBoolean(b);
    },
    kickback() {
      if (!this.databaseSet) {
        this.$router.push({ name: "home" });
      }
    },
  },
};
</script>
